import {Basic, Ventrata} from 'types'

export const convertUnitCounterMapToRequestUnitCounters = (
  map: Basic.UnitCounterMap
): Ventrata.RequestUnitCounter[] => {
  return Object.entries(map).map(([id, quantity]) => ({id, quantity}))
}
